import { Pipe, PipeTransform } from '@angular/core';
import {
  SWIADCZENIOBIORCY_FILTER_LABELS,
  SwiadczeniobiorcyFilter,
} from '../../../shared/enums/application-list-swiadczeniobiorcy.enum';
import {
  PRZEDSIEBIORCY_FILTER_LABELS,
  PrzedsiebiorcyFilter,
} from '../../../shared/enums/application-list-przedsiebiorcy.enum';

@Pipe({
  name: 'getApplicationCategoryName',
  standalone: true,
})
export class GetApplicationCategoryNamePipe implements PipeTransform {
  transform(filterValue: any): string | undefined {
    if (filterValue in SWIADCZENIOBIORCY_FILTER_LABELS) {
      return SWIADCZENIOBIORCY_FILTER_LABELS[
        filterValue as SwiadczeniobiorcyFilter
      ];
    }
    if (filterValue in PRZEDSIEBIORCY_FILTER_LABELS) {
      return PRZEDSIEBIORCY_FILTER_LABELS[filterValue as PrzedsiebiorcyFilter];
    }
    return undefined;
  }
}
